export default __webpack_public_path__ + "static/media/contact.80390d84.jpg";